import { actions } from './category_service/actions'
import { getters } from './category_service/getters'
import { state } from './category_service/state'
import { mutations } from './category_service/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
